// extracted by css-extract-rspack-plugin
export default {"bloko-information":"bloko-information","bloko-information_success":"bloko-information_success","bloko-information_warning":"bloko-information_warning"};